const config = require("../config.js");
const UTILS = require("./utils.js");
const vA392 = ["inverse", "linear", "exponential"];
class C245 {
  constructor() {
    this.queued = null;
    this.sounds = [];
    this.emitter = [];
    this.listener = {};
    this.rate = 1;
    this.volumes = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.soundCats = {
      nuke_0: 0,
      siren_0: 0,
      scare_0: 0,
      beep_0: 0,
      dragon_0: 0,
      egg_0: 0,
      ambient_1: 2,
      ambient_2: 2,
      ambient_3: 2,
      ambient_4: 2,
      ambient_5: 2,
      ambient_6: 2,
      ambient_7: 2,
      ambient_8: 2,
      ambient_9: 2,
      ambient_10: 2,
      gong_0: 2,
      ambient_11: 2,
      ambient_12: 2,
      ambient_13: 2,
      ambient_14: 2,
      ambient_15: 2,
      ambient_16: 2,
      ambient_17: 2,
      ambient_18: 2,
      ambient_19: 2,
      jug_0: 2,
      aim_0: 3,
      aim_1: 3,
      explosion: 3,
      gclick_0: 3,
      pick_0: 3,
      pick_1: 3,
      reload_1: 3,
      reload_2: 3,
      swsh_0_0: 3,
      swsh_0_1: 3,
      weapon_1: 3,
      weapon_1_0: 3,
      weapon_2: 3,
      weapon_3: 3,
      weapon_4: 3,
      weapon_5: 3,
      weapon_6: 3,
      weapon_7: 3,
      weapon_8: 3,
      weapon_9: 3,
      weapon_10: 3,
      weapon_11: 3,
      weapon_12: 3,
      weapon_13: 3,
      weapon_14: 3,
      weapon_15: 3,
      weapon_16: 3,
      weapon_17: 3,
      weapon_18: 3,
      whizz_0: 3,
      whizz_1: 3,
      weapon_6_0: 3,
      weapon_1_2: 3,
      weapon_3_0: 3,
      rico_1: 3,
      rico_2: 3,
      case_0: 3,
      case_1: 3,
      weapon_3_2: 3,
      weapon_2_0: 3,
      weapon_1_4: 3,
      weapon_1_3: 3,
      weapon_17_0: 3,
      weapon_8_0: 3,
      weapon_10_0: 3,
      melee_12: 3,
      swsh_12_0: 3,
      swsh_12_1: 3,
      weapon_4_0: 3,
      melee_equip: 3,
      melee_14: 3,
      swsh_14_0: 3,
      swsh_14_1: 3,
      weapon_1_5: 3,
      weapon_19: 3,
      melee_19: 3,
      swsh_19_0: 3,
      swsh_19_1: 3,
      weapon_11_0: 3,
      weapon_4_1: 3,
      weapon_4_2: 3,
      weapon_4_3: 3,
      weapon_7_0: 3,
      melee_25: 3,
      melee_25_1: 3,
      weapon_1_6: 3,
      weapon_7_1: 3,
      weapon_2_1: 3,
      weapon_1_7: 3,
      weapon_2_3: 3,
      swing_0: 3,
      weapon_9_0: 3,
      weapon_1_8: 3,
      weapon_3_16: 3,
      weapon_14_0: 3,
      weapon_10_1: 3,
      weapon_11_1: 3,
      melee_38: 3,
      weapon_12_0: 3,
      weapon_14_1: 3,
      weapon_6_1: 3,
      weapon_2_4: 3,
      weapon_10_2: 3,
      weapon_8_1: 3,
      weapon_5_0: 3,
      weapon_4_4: 3,
      weapon_20: 3,
      weapon_17_1: 3,
      weapon_3_3: 3,
      melee_42: 3,
      weapon_2_5: 3,
      weapon_1_12: 3,
      weapon_1_9: 3,
      weapon_2_6: 3,
      weapon_2_7: 3,
      weapon_2_8: 3,
      weapon_2_9: 3,
      weapon_5_1: 3,
      weapon_5_2: 3,
      weapon_7_2: 3,
      weapon_7_3: 3,
      weapon_7_4: 3,
      weapon_7_5: 3,
      weapon_9_1: 3,
      weapon_10_3: 3,
      weapon_15_1: 3,
      weapon_15_2: 3,
      weapon_15_3: 3,
      weapon_16_1: 3,
      weapon_6_2: 3,
      weapon_3_4: 3,
      weapon_4_6: 3,
      weapon_4_5: 3,
      weapon_1_11: 3,
      weapon_17_3: 3,
      weapon_2_10: 3,
      weapon_7_6: 3,
      weapon_8_2: 3,
      weapon_11_3: 3,
      weapon_1_10: 3,
      weapon_22: 3,
      weapon_17_4: 3,
      weapon_19_0: 3,
      weapon_12_1: 3,
      weapon_14_2: 3,
      weapon_1_13: 3,
      weapon_2_11: 3,
      weapon_3_6: 3,
      weapon_4_8: 3,
      weapon_5_3: 3,
      weapon_6_3: 3,
      weapon_7_7: 3,
      weapon_8_3: 3,
      weapon_9_2: 3,
      weapon_10_4: 3,
      weapon_11_4: 3,
      weapon_12_2: 3,
      weapon_14_3: 3,
      weapon_15_4: 3,
      weapon_16_2: 3,
      weapon_17_4: 3,
      weapon_19_1: 3,
      weapon_3_5: 3,
      weapon_9_3: 3,
      weapon_6_4: 3,
      weapon_2_13: 3,
      weapon_7_9: 3,
      melee_65: 3,
      weapon_28_0: 3,
      weapon_11_6: 3,
      weapon_10_6: 3,
      weapon_1_15: 3,
      weapon_1_16: 3,
      weapon_2_14: 3,
      weapon_6_6: 3,
      weapon_4_10: 3,
      weapon_2_15: 3,
      weapon_1_17: 3,
      weapon_23: 3,
      weapon_6_7: 3,
      weapon_2_16: 3,
      weapon_21: 3,
      weapon_6_8: 3,
      weapon_6_9: 3,
      weapon_11_7: 3,
      weapon_7_10: 3,
      weapon_24: 3,
      weapon_4_11: 3,
      weapon_1_18: 3,
      weapon_25: 3,
      weapon_26: 3,
      weapon_5_5: 3,
      weapon_1_19: 3,
      weapon_27: 3,
      weapon_28: 3,
      weapon_2_16: 3,
      weapon_11_7: 3,
      weapon_6_10: 3,
      weapon_1_20: 3,
      weapon_17_6: 3,
      weapon_3_8: 3,
      weapon_2_18: 3,
      weapon_29: 3,
      weapon_29_blast: 3,
      weapon_4_12: 3,
      weapon_1_21: 3,
      weapon_9_6: 3,
      weapon_4_13: 3,
      weapon_16_4: 3,
      weapon_4_14: 3,
      weapon_1_22: 3,
      weapon_8_5: 3,
      weapon_8_5_r_1: 3,
      weapon_8_5_r_2: 3,
      weapon_4_15: 3,
      weapon_6_11: 3,
      weapon_9_7: 3,
      weapon_upgraded: 3,
      weapon_14_5: 3,
      weapon_12_4: 3,
      weapon_3_9: 3,
      weapon_4_17: 3,
      weapon_5_6: 3,
      weapon_19_3: 3,
      weapon_1_23: 3,
      weapon_1_24: 3,
      weapon_4_18: 3,
      weapon_11_9: 3,
      weapon_29_2: 3,
      weapon_4_16: 3,
      weapon_2_19: 3,
      weapon_2_20: 3,
      weapon_10_7: 3,
      weapon_3_10: 3,
      fart_0: 4,
      headshot_0: 4,
      hit_0: 4,
      impact_0: 4,
      jump_0: 4,
      jump_1: 4,
      land_0: 4,
      punch_0: 4,
      punch_1: 4,
      slide_0: 4,
      spray: 4,
      step_0: 4,
      step_1: 4,
      step_2: 4,
      taunt_0: 4,
      taunt_1: 4,
      taunt_2: 4,
      taunt_3: 4,
      taunt_4: 4,
      cough_1: 4,
      cough_2: 4,
      collect_1: 4,
      bounce_0: 4,
      build_0: 4,
      break_wood: 4,
      taunt_5: 4,
      spray_1: 4,
      takedmg_0: 4,
      takedmg_1: 4,
      stepwo_0: 4,
      stepwo_1: 4,
      stepwat_0: 4,
      stepwat_1: 4,
      stepsa_0: 4,
      stepsa_1: 4,
      stepsno_0: 4,
      stepsno_1: 4,
      stepsno_2: 4,
      egg_1: 4,
      bounce_1: 4,
      zap_0: 4,
      crit_0: 4,
      reload_3: 4,
      buy_0: 5,
      buy_1: 5,
      cheer_0: 5,
      reward: 5,
      cheer_1: 5,
      store: 5,
      tick_0: 5,
      limited_0: 5,
      limited_1: 5,
      limited_2: 5,
      limited_3: 5,
      limited_4: 5,
      limited_5: 5,
      limited_6: 5,
      limited_7: 5,
      bundle_1: 5,
      bundle_2: 5,
      bundle_3: 5,
      bundle_4: 5,
      select_0: 5,
      hover_0: 5,
      bundle_5: 5,
      menu_0: 5,
      bundle_6: 5,
      bundle_7: 5,
      menu_1: 5,
      bundle_8: 5,
      bundle_9: 5,
      bundle_10: 5,
      bundle_11: 5,
      bundle_12: 5,
      bundle_13: 5,
      bundle_14: 5,
      bundle_15: 5,
      bundle_16: 5,
      bundle_17: 5,
      bundle_18: 5,
      bo_plant: 7,
      bo_diff: 7,
      bhop_reset: 7,
      bhop_check: 7,
      dom_zone_securing_0: 7,
      dom_zone_securing_1: 7,
      dom_zone_losing_0: 7,
      dom_zone_secured_0: 7,
      dom_zone_secured_1: 7,
      dom_zone_secured_2: 7,
      dom_zone_all_0: 7,
      dom_zone_all_1: 7,
      medal_0: 7,
      medal_1: 7,
      gift_0: 7,
      mystery_0: 7,
      mystery_1: 7,
      firesale_0: 7,
      firesale_1: 7,
      instantkill_0: 7,
      shoe_1: 8,
      shoe_2: 8,
      shoe_19: 8,
      shoe_28: 8,
      shoe_46: 8
    };
  }
  setVolume(p9805, p9806 = 0) {
    if (this.volumes[p9806] != null) {
      this.volumes[p9806] = p9805;
      if (p9806 == 0) {
        Howler.volume(p9805);
      }
      for (var v7949 in this.sounds) {
        if (this.sounds[v7949].cat == p9806) {
          this.sounds[v7949].volume(this.sounds[v7949].vol * this.volumes[p9806]);
        }
      }
    }
  }
  getSound(p9807, p9808, p9809, p9810, p9811, p9812) {
    var v7950 = p9807 + (p9808 || "") + (window.activeHacker ? "hckd" : "") + (p9809 ? "asset" : "");
    this.queued = this.sounds[v7950];
    if (!this.queued || this.queued.reset) {
      var v7951 = p9809 ? UTILS.userAssetsUrl(p9807 + "/sound.mp3") : UTILS.assetsUrl("/sound/" + (window.activeHacker ? "fart_0" : p9807) + ".mp3", undefined, p9811);
      this.queued = new Howl({
        src: v7951,
        volume: p9812,
        onload: p9810
      });
      this.queued.cat = p9809 ? 6 : this.soundCats[p9807] || 0;
      this.sounds[v7950] = this.queued;
      return false;
    }
    this.queued.cat = p9809 ? 6 : this.soundCats[p9807] || 0;
    return true;
  }
  getActive(p9813, p9814, p9815) {
    var v7952 = p9813 + (p9814 || "") + (window.activeHacker ? "hckd" : "") + (p9815 ? "asset" : "");
    return this.sounds[v7952];
  }
  onLoad(p9816, p9817, p9818) {
    this.getSound(p9816, null, p9818, p9817);
  }
  getVolume(p9819, p9820) {
    if (p9820) {
      return this.volumes[6];
    } else if (this.soundCats[p9819] == null) {
      return 1;
    } else {
      return this.volumes[this.soundCats[p9819]];
    }
  }
  play(p9821, p9822, p9823, p9824, p9825, p9826) {
    var v7953 = (p9822 || 1) * this.getVolume(p9821, p9825);
    this.getSound(p9821, null, p9825, undefined, p9826, v7953);
    if (this.rate && (!p9823 || !this.queued.isPlaying)) {
      this.queued.isPlaying = true;
      var v7954 = this.queued.play();
      this.queued.vol = p9822 || 1;
      this.queued.volume(v7953, v7954);
      if (p9823) {
        this.queued.loop(p9823, v7954);
      }
      if (p9824) {
        this.queued.rate((p9824 || 1) * this.rate, v7954);
      }
      return [this.queued, v7954];
    }
  }
  stop(p9827, p9828) {
    var v7955 = this.getActive(p9827, null, p9828);
    if (v7955) {
      v7955.isPlaying = false;
      v7955.stop();
    }
    v7955 = this.getActive(p9827, "3d", p9828);
    if (v7955) {
      v7955.isPlaying = false;
      v7955.stop();
    }
    v7955 = this.getActive(p9827, "3dv", p9828);
    if (v7955) {
      v7955.isPlaying = false;
      v7955.stop();
    }
  }
  endLoops() {
    for (var v7956 in this.sounds) {
      if (this.sounds[v7956] && this.sounds[v7956]._sounds[0]._loop) {
        this.sounds[v7956].isPlaying = false;
        this.sounds[v7956].stop();
      }
    }
  }
  stopALL() {
    for (var v7957 in this.sounds) {
      if (this.sounds[v7957]) {
        this.sounds[v7957].isPlaying = false;
        this.sounds[v7957].stop();
      }
    }
  }
  play3Dv2(p9829, p9830, p9831, p9832, p9833, p9834, p9835, p9836, p9837) {
    var v7958 = UTILS.getD3D(p9830, p9831, p9832, p9836.x, p9836.y, p9836.z);
    p9834 = (p9834 || 1) * (1 - v7958 / p9833) * config.otherSoundMlt;
    var v7959;
    var v7960 = p9834 * this.getVolume(p9829, p9837);
    var vF52 = () => {
      this.queued.vol = p9834;
      this.queued.volume(v7960, v7959);
      this.queued.rate(p9835 || 1, v7959);
    };
    const v7961 = this.getSound(p9829, "3dv", p9837, undefined, undefined, v7960);
    v7959 = this.queued.play();
    if (v7961) {
      vF52();
    } else {
      this.queued.on("load", vF52, v7959);
    }
  }
  play3Dv(p9838, p9839, p9840, p9841, p9842, p9843, p9844, p9845, p9846) {
    var v7962 = UTILS.getD3D(p9839, p9840, p9841, p9845.x, p9845.y, p9845.z);
    var v7963 = 1 - v7962 / p9842;
    if (v7963 > 0.1) {
      this.getSound(p9838, "3dv", p9846);
      var v7964 = this.queued.play();
      p9843 = (p9843 || 1) * v7963 * config.otherSoundMlt;
      var v7965 = p9843 * this.getVolume(p9838, p9846);
      this.queued.vol = p9843;
      this.queued.volume(v7965, v7964);
      this.queued.rate(p9844 || 1, v7964);
    }
  }
  play3D(p9847, p9848, p9849, p9850, p9851, p9852, p9853, p9854, p9855, p9856) {
    p9851 = (p9851 || 1) * config.otherSoundMlt;
    var v7966;
    var v7967 = p9851 * this.getVolume(p9847, p9855);
    var vF53 = () => {
      this.queued.vol = p9851;
      this.queued.volume(v7967, v7966);
      this.queued.rate(p9852 || 1, v7966);
      this.queued.pos(p9848, p9849, p9850, v7966);
      this.queued.pannerAttr({
        refDistance: p9853 || 25,
        rolloffFactor: p9854 || 1
      }, v7966);
    };
    const v7968 = this.getSound(p9847, "3d", p9855, undefined, p9856, v7967);
    v7966 = this.queued.play();
    if (v7968) {
      vF53();
    } else {
      this.queued.on("load", vF53, v7966);
    }
    return [this.queued, v7966];
  }
  update3DPos(p9857, p9858, p9859, p9860) {
    p9857[0].pos(p9858, p9859, p9860, p9857[1]);
    return [p9857[0], p9857[1]];
  }
  play3DL(p9861, p9862, p9863, p9864, p9865, p9866, p9867, p9868, p9869, p9870, p9871) {
    var v7969 = (p9865 || 1) * this.getVolume(p9861, p9869);
    this.getSound(p9861, "3d", p9869, undefined, undefined, v7969);
    var v7970 = this.queued.play();
    this.queued.vol = p9865 || 1;
    this.queued.volume(v7969, v7970);
    this.queued.rate(p9866 || 1, v7970);
    this.queued.pos(p9862, p9863, p9864, v7970);
    this.queued.pannerAttr({
      refDistance: p9867 || 25,
      rolloffFactor: p9868 || 1,
      distanceModel: vA392[p9870 || 0],
      maxDistance: 10000,
      coneOuterGain: 1
    }, v7970);
    this.queued.on("end", function (p9872) {
      if (!this.stopped) {
        this.isPlaying = true;
        this.seek(0, p9872);
        this.play(p9872);
      }
    });
    if (!p9871) {
      this.emitter.push(this.queued);
    }
    return [this.queued, v7970];
  }
  clearEmitters() {
    for (var vLN01296 = 0; vLN01296 < this.emitter.length; vLN01296++) {
      this.emitter[vLN01296].isPlaying = false;
      this.emitter[vLN01296].stop();
    }
    this.emitter.length = 0;
  }
  updateSound(p9873, p9874) {
    if (this.soundCats[p9873] && this.soundCats[p9873] == 2) {
      this.stop(p9873);
    }
    this.sounds[p9873] = new Howl({
      src: [p9874],
      format: "mp3"
    });
    this.sounds[p9873 + "3d"] = new Howl({
      src: [p9874],
      format: "mp3"
    });
    this.sounds[p9873 + "3dv"] = new Howl({
      src: [p9874],
      format: "mp3"
    });
  }
  reset() {
    for (var v7971 in this.sounds) {
      this.sounds[v7971].reset = true;
    }
  }
}
module.exports = C245;